module.exports = __webpack_public_path__ + "static/media/new-products-item-1.be570f87.png";